<header class="header">
  <section class="position-fixed w-100 top-0 header-logo-links d-flex align-items-center" [ngClass]="{'justify-content-between': isMobView}">
    <div class="logo-wrapper mx-4" [ngClass]="{ 'overlay_index': showMenu }">
      <a class="d-flex w-100 justify-content-center" [href]="originUrl">
        <img class="w-75" src="/cs/cop/assets/images/Avaya-OneCare-Portal-Logo.png" alt="Avaya Sales &amp; Partner Portal" />
      </a>
    </div>

    <!-- for mobile view only -->
    <div class="position-relative d-block d-md-none me-3" [ngClass]="{ 'overlay_index': showMenu }">
      <mat-icon class="cursor-pointer" (click)="toggleMobileview()">
        @if (showMenu) { close } @else { menu }
      </mat-icon>
    </div>

    <ul class="d-flex header-links" [class.show]="showMenu" [ngClass]="{'flex-row align-items-center': !isMobView}">
      <!-- Left side menus -->
      @for (link of leftMenus; track link.id) {
        <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3': !isMobView }">
          @if (link.openinsamewindow === 'false' && !link.logoimage && link.id !== '1397208679419') {
            <a class="d-flex align-items-center menu_label" (click)="linkTarget(link, _blank)">
              {{ link.title }}
              @if (link.HasSubHeaderLink) { <mat-icon class="ms-1">keyboard_arrow_down</mat-icon> }
            </a>
          }
          @if (link.openinsamewindow === 'true' && !link.logoimage && link.id !== '1397208679419') {
            <a class="d-flex align-items-center menu_label" (click)="linkTarget(link, self)">
              {{ link.title }}
              @if (link.HasSubHeaderLink) { <mat-icon class="ms-1">keyboard_arrow_down</mat-icon> }
            </a>
          }
          @if (link.openinsamewindow === 'true' && !link.logoimage && link.id !== '1397208679419' && link.alttext === 'signin' && userInfo.uid) {
            <a class="d-flex align-items-center menu_label" (click)="linkTarget(link, self)">
              {{ link.title }}
              @if (link.HasSubHeaderLink) { <mat-icon class="ms-1">keyboard_arrow_down</mat-icon> }
            </a>
          }
          @if (link.id == '1397208679419') {
            <a class="d-flex align-items-center menu_label" (click)="showOutage()">
              {{ link.title }}
              @if (link.HasSubHeaderLink) { <mat-icon class="ms-1">keyboard_arrow_down</mat-icon> }
            </a>
          }
          @if (link.logoimage && link.alttext === "ReportOutage") {
            <a class="d-flex align-items-center" style="width: 150px;" href="{{ link.url }}">
              <img class="w-100" src="{{ link.logoimage }}" alt="outage" />
            </a>
          }

          @if (link.HasSubHeaderLink && !hideListMenus) {
            <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
              @for (sub of link.SubHeaderLinks; track sub.id) {
                <li copSubDropdown class="menu">
                  <a href="{{sub.url}}" class="d-flex w-100 px-3 py-2">
                    {{ sub.title }}
                    @if (sub.HasSubHeaderLink) { <mat-icon>keyboard_arrow_right</mat-icon> }
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }

      @for (link of rightMenus; track link.id) {
        @if (link.alttext === 'language') {
          <li class="menuList cursor-pointer position-relative" copDropdown (clickOutside)="closeMenuItems()" [ngClass]="{ 'me-3 ms-auto': !isMobView }">
            <a class="d-flex align-items-center">
              <!-- Language icon min-width: 768px -->
              <span class="cursor-pointer d-md-flex d-none">
                <mat-icon class="thin-icon fs-3" [ngClass]="{'mt-2': isNoLeftMenus}">language</mat-icon>
              </span>

              <!-- Language label max-width: 767px -->
              <span class="w-100 cursor-pointer d-flex d-md-none" [ngClass]="{'justify-content-between': isMobView}">
                <span class="d-flex align-items-center">
                  <mat-icon class="thin-icon fs-3 me-2">language</mat-icon>
                  <span class="fw-light">{{ link.title }}</span>
                </span>
                <mat-icon class="ms-1">keyboard_arrow_down</mat-icon>
              </span>
            </a>

            <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
              @for (sub of link.SubHeaderLinks; track sub.id) {
                <li copSubDropdown class="menu">
                  <a href="{{sub.url}}" class="d-flex justify-content-between align-items-center w-100 px-3 py-2">
                    {{ sub.title }}
                    @if (sub.isSelectedLang) { <mat-icon class="fs-5">check</mat-icon> }
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      }

      <li class="menuList cursor-pointer position-relative" [ngClass]="{ 'me-3': !isMobView }">
        <a class="d-flex align-items-center" (click)="showHideSearch = !showHideSearch;">
          <mat-icon class="mt-1 fs-3" [ngClass]="{ 'me-2': isMobView }">search</mat-icon>
          <span class="d-inline-block d-md-none fw-light">{{ 'search' | translate }}</span>
        </a>
      </li>

      <li copDropdown (clickOutside)="closeMenuItems()" class="menuList cursor-pointer position-relative" [ngClass]="{ 'me-3': !isMobView }">
        <button type="button" class="gradient_btn round_border" (click)="OpenRequestsView('my')">
          {{ 'myRequests' | translate }}
        </button>
      </li>

      @if (userInfo.uid || userInfo['E-mail']) {
        <li class="menuList cursor-pointer position-relative cop-prof" copSubDropdown (clickOutside)="closeProfileDropdown()" [ngClass]="{ 'me-3': !isMobView, 'w-100': isMobView }">
          <a class="d-flex align-items-center">
            <mat-icon class="cursor-pointer thin-icon fs-3" [ngClass]="{ 'me-2': isMobView }" (click)="openProfileDropdown()">account_circle</mat-icon>
            <span class="img-cursor d-inline-block d-md-none fw-light" (click)="openProfileDropdown()">
              {{ 'profile' | translate }}
            </span>
          </a>

          <ul class="bg-white menu-dropdown" [ngClass]="{'position-absolute': !isMobView, 'mt-2': isMobView}">
            @if (infoMenu) {
              <li class="menu">
                <a class="d-flex w-100 px-3 py-2" (click)="doNothing()" [attr.title]="userType">
                  {{ firstName }} {{ lastName }}
                </a>
              </li>
              @if (views.length > 1 && (userInfo.uid || userInfo['E-mail'])) {
                <li class="menu" (click)="openDefaultView()">
                  <a class="d-flex w-100 px-3 py-2">
                    {{'defaultView' | translate}}
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </a>
                </li>
                <li class="menu" (click)="openDelgatesView()">
                  <a class="d-flex w-100 px-3 py-2">
                    {{'OneCareDelegation' | translate}}
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </a>
                </li>
              }
              <li class="menu" (click)="onLogout()">
                <a class="d-flex w-100 px-3 py-2" href="{{logout}}">
                  {{ 'OneCareLogout' | translate }}
                </a>
              </li>
            }

            @if (viewSettingIcon) {
              <div class="d-inline-flex align-items-center small" (click)="backToMainMenu(); $event.stopPropagation();">
                <mat-icon>keyboard_arrow_left</mat-icon>
                {{ 'OneCareBack' | translate }}
              </div>
              <div class="row m-0">
                <div class="col-12 p-3 mt-3 mb-2">
                  <label class="small fw-bold">
                    {{ 'defaultView' | translate }}
                  </label>
                  <select class="form-control round_border p-1" [(ngModel)]="viewId" id="viewDataOption" style="font-size: 13px;">
                    <option *ngFor="let view of views" [value]="view.id" [selected]="view.defaultview">
                      {{ view.title }}
                    </option>
                  </select>
                </div>
                <div class="col-12 text-center py-2" *ngIf="views.length > 1">
                  <button type="submit" class="gradient_btn round_border py-2" (click)="selectChangeHandler()" [disabled]="buttonDisabled">
                    {{ 'OneCareApply' | translate }}
                  </button>
                </div>
              </div>
            }

            @if (defaultSettingIcon) {
              <div class="d-inline-flex align-items-center small" (click)="backToMainMenu(); $event.stopPropagation();">
                <mat-icon>keyboard_arrow_left</mat-icon>
                {{ 'OneCareBack' | translate }}
              </div>
              <div class="row m-0">
                <div class="col-12 p-3 mt-3 mb-2">
                  <label class="small fw-bold">{{'delegates' | translate}}</label>
                  <form [formGroup]="userprofileForm">
                    <div formArrayName="mobiles">
                      <p *ngIf="showInvalidDelegationMsg" class="invalidMsg">{{'invalidDelegation' | translate}}</p>
                      <div *ngFor="let addedUseres of responseArray; let i=index" class="user-row">
                        <div class="delegationStatic" title="{{addedUseres}}">{{addedUseres}}</div>
                        <div (click)="deleteInitialValue(i); $event.stopPropagation();" class="cross-btn img-cursor">
                          &times;
                        </div>
                      </div>
                      <ng-container *ngIf="!hideInitalResponseInputBox">
                        <div *ngFor="let mob of mobiles?.controls; let i=index">
                          <input type="text" [formControlName]="i" class="form-control round_border p-1" style="font-size: 13px;">
                          <span *ngIf="mobiles.controls.length >1 " (click)="deleteRow(i);  $event.stopPropagation();"
                            class="delegation-cross-btn">&times;</span>
                        </div>
                      </ng-container>
                    </div>
                  </form>
                </div>

                <div class="col-12 delegate_apply">
                  <mat-icon class="cursor-pointer" *ngIf="addButtonFlag" (click)="addInputDeligation(); $event.stopPropagation();">add_circle_outline</mat-icon>
                  <!-- <img *ngIf="addButtonFlag"
                    src="/cs/cop/assets/svg/add-circular-outlined-button.png" /> -->
                </div>

                <div class="col-12 py-2">
                  <button type="submit" class="gradient_btn round_border py-2 me-2" (click)="saveDelegatesList();" [disabled]="disableApplySetting">
                    {{ 'OneCareApply' | translate }}
                  </button>
                  <button type="submit" class="gradient_btn round_border py-2" (click)="backToMainMenu(); $event.stopPropagation();">
                    {{ 'OneCareCancel' | translate }}
                  </button>
                </div>
              </div>
            }
          </ul>
        </li>
      }
    </ul>

    <!-- Global Search bar -->
    @if (showHideSearch) {
      <div class="d-flex align-items-center position-absolute bg-white py-2 px-1 search_layout" [ngClass]="{ 'w-100': isMobView, 'overlay_index': showHideSearch }">
        <div class="d-flex align-items-center position-relative w-100 px-2 py-1 search_bar">
          <mat-icon class="position-absolute cursor-pointer" (click)="onOptionsSelected({target: { value: '' }}, searchCtrl.value)">search</mat-icon>
          <input type="text" class="w-100 border-0 py-2 ps-4" #fileinput placeholder="{{'OneCareSearchPlaceholder' | translate}}"
            (keyup)="getfileinput($event, null)" [formControl]="searchCtrl" [matAutocomplete]="searchautocomplete" [autofocus]="false" />
          <select class="position-absolute border-0 bg-transparent text-truncate search_dropdown" (change)="onOptionsSelected($event, $event.target.value)">
            <option value="{{ 'OneCareAvayaKnowledge' | translate }}" selected>
              {{ 'OneCareAvayaKnowledge' | translate }}
            </option>
            <option value="{{ 'OneCareServiceCatalog' | translate }}">
              {{ 'OneCareServiceCatalog' | translate }}
            </option>
          </select>
          <a class="ms-2 d-inline-flex" target="_blank" rel="noopener noreferrer" href="https://support.avaya.com/ext/index?page=content&id=ITKB106640">
            <mat-icon title="{{ 'searchTips' | translate }}">info_outline</mat-icon>
          </a>
        </div>

        <!-- search close button -->
        <mat-icon class="cursor-pointer" (click)="resetSearch()">close</mat-icon>

        <!-- Search suggestion dropdown -->
        <mat-autocomplete #searchautocomplete="matAutocomplete">
            @if (isLoading) {
            <mat-option>
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </mat-option>
          }
          @for (suggestion of suggestionList; track option) {
            <mat-option (click)="getfileinput({'keyCode': 13}, suggestion)">
              <span [innerHTML]="suggestion | highlight: toHighlight"></span>
            </mat-option>
          } @empty {
            <mat-option disabled>No suggestions found</mat-option>
          }
        </mat-autocomplete>
      </div>
    }
  </section>
</header>